import { useLocation } from 'wouter';
import { Button } from '@/components/ui/button';
import { ArrowUpRight } from 'lucide-react';
import { useSubscription } from '@/hooks/use-subscription';

export function UpgradePlanButton() {
  const { subscription } = useSubscription();
  const [, navigate] = useLocation();
  
  const handleClick = () => {
    // Navigate directly to subscription page with plans tab active
    navigate('/subscription?tab=plans');
  };
  
  // If we're on a paid plan, show "Manage Subscription" instead
  const isPaidPlan = subscription && 
    subscription.plan && 
    subscription.plan.id !== 'free';
    
  const buttonText = isPaidPlan ? 'Manage Plan' : 'Upgrade Plan';
  
  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleClick}
      className="flex items-center gap-1"
    >
      {buttonText}
      <ArrowUpRight className="h-3.5 w-3.5" />
    </Button>
  );
}